//Compile contract
//solc contracts/MedicalHistory.sol --combined-json abi,asm,ast,bin,bin-runtime,devdoc,interface,opcodes,srcmap,srcmap-runtime,userdoc > src/contracts/MedicalVisit.json
//solc contracts/PatientRegistry.sol --combined-json abi,asm,ast,bin,bin-runtime,devdoc,interface,opcodes,srcmap,srcmap-runtime,userdoc > src/contracts/PatientRegistry.json

import gun from './gun'
let contractJSON = require('../contracts/MedicalVisit.json')
let abi = contractJSON.abi;
import Gun from 'gun'
const sea = Gun.SEA

let bytecode = '0x' + contractJSON.bytecode.object;
class PatientManager {
    static CreateHospitalization(patient, files, external, date, medicPub) {
        return new Promise((resolve) => {
            var web3 = window.web3

            // Create Contract proxy class

            web3.eth.getGasPrice().then(price => {
                let MedicalHistoryContract = new web3.eth.Contract(abi, null, { data: bytecode, gasPrice: price });

                var tx = MedicalHistoryContract.deploy({ arguments: [date, patient.wallet, patient.reason, files.map(e => [e.name, e.fileHash]), external.map(e => [e.name, e.fileHash])] }, { gasPrice: price })

                web3.eth.getAccounts().then(accounts => {
                    tx.estimateGas().
                        then((estimatedGas) => {
                            console.log(price)
                            let contractBlock = tx.send({ from: window.web3.eth.defaultAccount, gas: estimatedGas + 10000, gasPrice: price })
                            contractBlock.then(async (e) => {
                                var data = {
                                    externalID: e._address,
                                    owner: accounts[0]
                                };
                                var patientKeys = await gun.user(patient.pub)
                                var secret = await sea.secret(patientKeys.epub, gun.user()._.sea)
                                var encryptedData = await sea.encrypt(data, secret)
                                console.log("create hospitalization")
                                gun.user().get("hospitalizations").set({ data: encryptedData, patient: patient.pub, medic: medicPub }).once(function () {
                                    gun.get("hospitalizations").set(this)
                                })
                                resolve(e._address)
                            })
                        }).
                        catch(console.error);
                }
                )
            })

        })


    }
    static GetVisit(id) {
        var web3 = window.web3
        let MedicalHistoryContract = new web3.eth.Contract(abi, id);
        return MedicalHistoryContract
    }

    static getRegisteredVisits() {
        return new Promise((resolve) => {
            // axios.get('/api/contracts').then((result) => {
            //     resolve(result.data);
            // })
            resolve(gun.get('visits').map())
        })

    }
}

export default PatientManager